import Vue from 'vue'
import domUtils from 'util/dom-utils'
import log from 'util/logger'

export function createAndMountInstance(existingInstance: Vue, widget, divId: string): Promise<Vue> {
  return new Promise((resolve) => {
    if (existingInstance) {
      existingInstance.$destroy()
    }
    // if the dom element already exists, no need to wait for dom ready
    if (document.getElementById(divId)) {
      resolve(createInstance(widget, divId))
      return
    }
    domUtils.onDomReady().then(() => {
      if (document.getElementById(divId)) {
        resolve(createInstance(widget, divId))
        return
      }
      resolve()
      log.warn(`Widget not loaded at dom ready. Could not find div with id ${divId}.`)
    })
  })
}

function createInstance(widget, divId: string) {
  return new Vue({
    el: `#${divId}`,
    render: h => h(widget, {
      attrs: { id: divId }
    })
  })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/util/loader-helper.ts